import IpListType from 'client/Security/IpListType';
import IpListsApi from 'client/api/v2/IpListsApi';
import createModel from 'client/store/modules/models/createModel';

const model = createModel(() => new IpListType(), 'id', IpListsApi);

export default {
  namespaced: true,

  state: {
    ...model.state,
  },

  actions: {
    ...model.actions,
  },

  getters: {
    ...model.getters,

    displayName: state => state.item.name,
  },

  mutations: {
    ...model.mutations,
  },
};
